<div class="cloud-connection">
  <div class="row file-wrapper">
    @for (slide of showIconMapped[IndexIc]; track slide; let in = $index) {
      <div class="col-4 text-center">
        <div class="mb-10">
          <i class="font-70" [ngClass]="slide.type"></i>
        </div>
        <fn-base-input type="TEXT" [(ngModel)]="slide.name" [disabled]="true"></fn-base-input>
      </div>
    }
    <i class="fn-global-downArrow-o left-rotate carousel-icons font-25"
    [ngClass]="this.IndexIc === 0 ? 'd-none' :'d-block' " (click)="getToPrev()"></i>
    <i class="fn-global-downArrow-o right-rotate carousel-icons font-25"
      [ngClass]="this.IndexIc < this.showIconMapped.length - 1 ? 'd-block' :'d-none' "
    (click)="goToNext()"></i>
  </div>
  @if (showIconMapped.length > 1) {
    <ol class="indicators text-center mt-10 p-0">
      @for (dot of showIconMapped; track dot; let i = $index) {
        <li [ngClass]="IndexIc === i ? 'active' :'' "
        (click)="changePageRender(i)"></li>
      }
    </ol>
  }
</div>